import type {
    BookingSchedulingPolicy,
    BookingSchedulingPolicyInput,
    BookingServiceWindow,
} from 'owa-graph-schema';
import mapToBookingServiceWindowInput from './mapToBookingServiceWindowInput';

const mapToBookingSchedulingPolicyInput = (
    schedulingPolicy: BookingSchedulingPolicy
): BookingSchedulingPolicyInput => {
    const {
        allowStaffSelection,
        maximumAdvance,
        minimumLeadTime,
        sendConfirmationsToOwner,
        timeSlotInterval,
        bookingServiceWindows,
    } = schedulingPolicy;

    const modifiedSchedulingPolicy: BookingSchedulingPolicyInput = {
        allowStaffSelection,
        maximumAdvance,
        minimumLeadTime,
        sendConfirmationsToOwner,
        timeSlotInterval,
        bookingServiceWindows: mapToBookingServiceWindowInput(
            bookingServiceWindows as BookingServiceWindow[]
        ),
    };
    return modifiedSchedulingPolicy;
};

export default mapToBookingSchedulingPolicyInput;
